<template>
  <div>
    <wc-page-title title='Expenses'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            :title='toolbarData.title'
            :titleIcon='toolbarData.icon'
            :titleIconColor='toolbarData.iconColor'
            showAdd
            showSearch
            v-model='search'
            @add='add'
          >
              <v-data-table
                dense
                :items='expenses'
                :headers='headers'
                :rows-per-page='20'
                :search='search'
                @click:row='editExpense'
                :loading='isLoading'
              >
                <template v-slot:item.expense_date='{ item }'>
                  {{ item.expense_date | shortDate }}
                </template>
                <template v-slot:item.is_posted='{ item }'>
                  <posted-chip :posted='item.is_posted' small></posted-chip>
                </template>
                <template v-slot:item.purchased_by='{ item }'>
                  <span v-if='item.purchased_by'>{{ item.purchased_by_obj.name_display }}</span>
                </template>
                <template v-slot:item.total='{ item }'>
                  {{ item.total | dec }}
                </template>
              </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

    <new-expense-dialog
      :showDialog=showDialog
      @cancel='showDialog = false'
    ></new-expense-dialog>
  </div>
</template>

<script>
import accountingAPI from '@/api/accounting';
import formRules from '@/mixins/formRules';
import budgetsAPI from '@/modules/management/api/budgets';
import WCPosted from '@/components/chips/WCPosted';
import NewExpenseDialog from '@/modules/accounting/components/NewExpenseDialog';

export default {
  name: 'post-expenses',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    isSaving: false,
    isFormValid: false,
    showDialog: false,
    search: '',
    budget: null,
    budgetLineItems: [],
    expenses: [],
    expenseCopy: {},
    staff: [],
    headers: [
      { text: 'Expense Date', value: 'expense_date' },
      { text: 'Posted?', value: 'is_posted' },
      { text: 'Store/Location', value: 'purchased_at' },
      { text: 'Purchased by', value: 'purchased_by' },
      { text: 'Paid With', value: 'payment_account_display', align: 'center', width: '150'},
      { text: 'Total', value: 'total', align: 'right', width: '150'}
    ]
  }),
  computed: {
    toolbarData () {
      return this.$store.state.icons.dataBox.expenses
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.budget = await budgetsAPI.getActiveBudget();
      this.expenses = await accountingAPI.getExpenses();
      this.isLoading = false
    },
    toggleShowArchived () {
      this.showArchived = !this.showArchived
    },
    async add () {
      this.showDialog = true
    },
    editExpense (exp) {
      this.$router.push({ name: 'ExpenseOverview', params: { id: exp.id } })
    }
  },
  components: {
    'posted-chip': WCPosted,
    'new-expense-dialog': NewExpenseDialog
  }
}
</script>
